<!--
 - Manage attachments component
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @copyright (c) 2022 Build Centrix
 -->
<div class="order-attachments-upload">
  <bc-templates-modal-layout
    [isLoading]="isLoading"
    [loadingText]="('actions.loading'|translate)"
    (onCloseButtonClicked)="onDismiss()"
  >
    <!--Dialog Title-->
    <div title-content>
      <span *ngIf="!isPending">
        {{'order.details.attachments.manage.title'|translate: { count:
        filesCount } }}
      </span>
      <span *ngIf="isPending">
        {{'order.details.attachments.pending.title'|translate: { count:
        filesCount } }}
      </span>
    </div>
    <!--Dialog Content-->
    <div body-content>
      <div class="row">
        <div class="col-sm-12">
          <div [hidden]="isLoading">
            <form #attachmentsForm="ngForm">
              <table class="table-headed table-striped">
                <thead>
                  <tr>
                    <th class="text-left">Name / Description</th>
                    <th class="text-center">Size</th>
                    <th class="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of files">
                    <td class="text-left file-column">
                      <div class="title" *ngIf="isPending">{{ item.name }}</div>
                      <div class="title" *ngIf="!isPending">
                        {{ item.originalFileName }}
                      </div>
                      <div class="description">
                        <bc-atoms-input
                          id="fileDescription"
                          name="fileDescription"
                          title="{{'order.details.attachments.files.notes.description'|translate}}"
                          placeholder="{{'order.details.attachments.files.notes.title'|translate}}"
                          size="small"
                          [disabled]="item.isRemoving"
                          [(model)]="item.description"
                          (modelChange)="onChanges()"
                        >
                        </bc-atoms-input>
                      </div>
                    </td>
                    <td class="text-center size-column" *ngIf="isPending">
                      {{item.size|BcxBytes}}
                    </td>
                    <td class="text-center size-column" *ngIf="!isPending">
                      {{item.filesize?.value|BcxBytes}}
                    </td>
                    <td class="text-center button-column">
                      <div *ngIf="!isPending">
                        <a [href]="item.url" target="_blank">
                          <bc-atoms-button
                            [label]="('actions.download'|translate)"
                            [title]="('actions.download'|translate)"
                            [disabled]="item.isRemoving"
                            type="link"
                            icon="download"
                            display="block"
                            size="small"
                          >
                          </bc-atoms-button>
                        </a>
                      </div>
                      <div *ngIf="!isPending">
                        <bc-atoms-button
                          [label]="('actions.remove'|translate)"
                          [title]="('actions.remove'|translate)"
                          [loading]="item.isRemoving"
                          [disabled]="item.isRemoving"
                          type="linkDanger"
                          icon="delete"
                          display="block"
                          size="small"
                          [confirmTitle]="('actions.removeType'|translate:{ type:('order.details.attachments.title'|translate) })"
                          (onButtonClicked)="onRemoveFile(item)"
                        >
                          <div confirmation-body>
                            <div>
                              {{'prompts.confirmDeleteType'|translate: { type:
                              item.originalFileName } }}
                            </div>
                          </div>
                        </bc-atoms-button>
                      </div>
                      <div *ngIf="isPending">
                        <bc-atoms-button
                          [label]="('actions.remove'|translate)"
                          [title]="('actions.remove'|translate)"
                          type="linkDanger"
                          icon="delete"
                          display="block"
                          size="small"
                          (onButtonClicked)="onRemoveFile(item)"
                        >
                        </bc-atoms-button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </form>
          </div>
          <div [hidden]="!isLoading">
            <bc-atoms-loader
              [title]="isPending ? ('actions.uploading'|translate) : ('actions.saving'|translate)"
              [subtitle]="''"
              [active]="true"
              [fullscreen]="false"
            >
            </bc-atoms-loader>
          </div>
        </div>
      </div>
      <div class="row mt-2" *ngIf="postSize">
        <div class="col-12">
          <hr />
          <div [hidden]="isLoading">
            <ngb-progressbar type="success" [value]="postSizePercentage"
              >{{postSize|BcxBytes}}</ngb-progressbar
            >
            <div class="progress-subtitle">
              <span>{{maxFilePostSize|BcxBytes}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Dialog Actions-->
    <div footer-content>
      <div class="buttons-container">
        <div class="right-buttons">
          <!--Cancel/Close -->
          <bc-atoms-button
            [label]="('actions.cancel'|translate)"
            [title]="('actions.cancel'|translate)"
            [disabled]="isLoading"
            type="default"
            icon="cancel"
            display="block"
            size="small"
            (onButtonClicked)="onDismiss()"
          >
          </bc-atoms-button>
          <!--Save -->
          <bc-atoms-button
            *ngIf="!isPending"
            [label]="('actions.save'|translate)"
            [title]="('actions.save'|translate)"
            [disabled]="files.length === 0 || isLoading || !isChanges"
            type="success"
            icon="save"
            display="block"
            size="small"
            (onButtonClicked)="onSubmit(attachmentsForm.form)"
          >
          </bc-atoms-button>
          <!--Upload -->
          <bc-atoms-button
            *ngIf="isPending"
            [label]="('actions.upload'|translate)"
            [title]="('actions.upload'|translate)"
            [disabled]="files.length === 0 || isLoading"
            type="success"
            icon="upload"
            display="block"
            size="small"
            (onButtonClicked)="onSubmit(attachmentsForm.form)"
          >
          </bc-atoms-button>
        </div>
      </div>
    </div>
  </bc-templates-modal-layout>
</div>
